import protoRoot from "../proto-root";
import LullabyPlayerTimerSettings from "../private/LullabyPlayerTimerSettings";

const name = "setLullabyPlayerTimerRpcRequest";

function create(timerSettings) {
  const SetLullabyPlayerTimerRpcRequest = protoRoot.lookupType(
    "comm.SetLullabyPlayerTimerRpcRequest"
  );

  const request = SetLullabyPlayerTimerRpcRequest.create({
    timerSettings: LullabyPlayerTimerSettings.create(timerSettings)
  });

  return { payload: request, name };
}

export default {
  create,
  name
};

// message SetLullabyPlayerTimerRpcRequest {
//   LullabyPlayerTimerSettings timerSettings = 1;
// }
